import React, { useEffect, useState } from "react";
import { Tabs, Box, Tab } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import { handleAxiosError } from "../../../config/action-config";
import AssetsForm from "../assetsComponents/KT.assests.form";
import { useParams } from "react-router-dom";
import { getLatestStatusDetailsById } from "../../../api/resignation";
export default function AssetsChecklistDetail() {
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const [tabIndex, setTabIndex] = useState(0);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const [foundStatus, setFoundStatus] = useState("");
  const [latestStatus, setLatestStatus] = useState("");

  useEffect(() => {
    if (location.state?.employeeId) {
      getLatestStatus();
    } else {
      navigate("/resignation-request");
    }
  }, []);
  async function getLatestStatus() {
    try {
      const { data } = await getLatestStatusDetailsById(
        location.state?.employeeId,
        user.token
      );
      setLatestStatus(data.data[0].status_details);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  return (
    <Box sx={{ borderBottom: 1, width: "100%", borderColor: "divider" }}>
      <Tabs
        value={tabIndex}
        onChange={(e, nv) => {
          setTabIndex(nv);
        }}
        aria-label="basic tabs example"
      >
        <Tab
          label="Assets Checklist"
          id="simple-tab-2"
          aria-controls="simple-tabpanel-1"
          style={{ paddingLeft: 10, paddingRight: 10 }}
        />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <AssetsForm latestStatus={latestStatus} />
      </TabPanel>
    </Box>
  );
}
